import { BaseError } from './BaseError.js';
import { MIDDLEWARE_ERROR_MESSAGES, type MiddlewareErrorCode } from './constants.js';

/**
 * Custom Error class to be used within payment flow (see createPayment).
 * Every intentional exception within the payment flow should use this Error class with a significant error code.
 */
export class MiddlewarePaymentError extends BaseError<MiddlewareErrorCode> {
  constructor({ clientCode, code, extraData }: { clientCode: MiddlewareErrorCode; code?: string; extraData?: object }) {
    const message = MIDDLEWARE_ERROR_MESSAGES[clientCode];

    super({ clientCode, code, extraData, message });
    this.name = 'MiddlewarePaymentError';
  }

  override get handledError(): boolean {
    return true;
  }
}
